// extracted by mini-css-extract-plugin
module.exports = {"testimonials":"TrustedBy_testimonials__TBMza","testimonial_item":"TrustedBy_testimonial_item__CdyX9","video_item":"TrustedBy_video_item__22VbW"};